export default "__VITE_ASSET__eedd3fac__"